import { Field } from "formik";
import { get } from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectSelectedNode } from "../dataModels.selectors";
import { EMPTY_ARRAY, INDEX } from "../../../constants";

const { FIRST } = INDEX;

const AssignInputField = ({ name, node, handleChange, setFieldValue }) => {
  const selectedNode = useSelector(selectSelectedNode);
  const [options, setOptions] = useState(EMPTY_ARRAY);
  const [selectedOptions, setSelectedOptions] = useState(EMPTY_ARRAY);

  useEffect(() => {
    setFieldValue(name, selectedOptions);
  }, [setFieldValue, name, selectedOptions]);

  useEffect(() => {
    const selectedNodeInputs = get(node, "inputs", EMPTY_ARRAY);
    const selectedNodeOutputs = get(node, "outputs", EMPTY_ARRAY);

    const outputHandlerOptions = selectedNodeInputs.map((input) => {
      const availableOutputHandler = selectedNodeOutputs.find(
        (eachOutput) => eachOutput.key === `${input.key}_${name}`
      );

      const doesHandleExist = !!availableOutputHandler;
      const id = doesHandleExist
        ? availableOutputHandler.key
        : `${input.key}_${name}`;

      return {
        id,
        doesHandleExist,
        name: input.name,
        value: `${input.name.split("_")[FIRST]}_${name}`,
        type: name,
      };
    });
    setOptions(outputHandlerOptions);
    setSelectedOptions(
      outputHandlerOptions.filter(({ doesHandleExist }) => doesHandleExist)
    );
    setFieldValue(name, outputHandlerOptions)
  }, [name, selectedNode, node, setFieldValue]);

  const handleUpdate = (e, handlerName) => {
    const targetId = e.target.id;
    const doesHandleExist = e.target.checked;
    if (doesHandleExist) {
      setSelectedOptions((options) => [...options, targetId]);
      handleChange(targetId, name, handlerName);
    } else {
      setSelectedOptions((options) =>
        options.filter((option) => option !== targetId)
      );
      handleChange(targetId, name);
    }
  };

  return (
    <div className="text-sm m-2">
      {options.map(({ id, name, value, type, doesHandleExist }) => (
        <div className="flex items-center mb-1" key={id}>
          <label>
            <Field
              type="checkbox"
              name={name}
              onChange={(e) => handleUpdate(e, value)}
              className="mr-2"
              id={id}
              checked={doesHandleExist}
            />
            {name}
            <span className="text-xs italic font-thin"> ({type})</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default AssignInputField;
